import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import Axios from 'axios';
import _ from 'lodash';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { PrimeIcons } from 'primereact/api';

import Config from '../config';

import Utils from '../Utils';

const WholesalerData = () => {
    const { code } = useParams();
    const [wholesaler, setWholesaler] = useState({});
    const [data, setData] = useState([]);
    const [modificationTime, setModificationTime] = useState();
    const [loading, setLoading] = useState(true);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 20,
        page: 1,
        sortField: 'id',
        sortOrder: -1,
        filters: {
          'aic': { value: null, matchMode: 'equals' }
        }
    });

    useEffect(() => {
        loadLazyData();
    }, [code, lazyParams]);

    const loadLazyData = () => {
        setLoading(true);

        Axios.post(Config.API_BASE_URL+"/api/wholesalers/"+code, lazyParams)
            .then(result => result.data)
            .then(result => {
                setWholesaler(result.data.wholesaler);
                setData(result.data.rows);
                setModificationTime(result.data.filemtime);
                setLoading(false);
            });
    };

    const onFilter = params => {
        setLazyParams(_.merge(params, { first: 0 }));
    }
    const onSort = params => setLazyParams(params);
    const onPage = params => setLazyParams(params);

    const rowCost = row => Utils.formatCurrency(row.cost);
    const rowPrice = row => Utils.formatCurrency(row.price);
    const rowSuggestedPrice = row => Utils.formatCurrency(row.suggested_price);

    const download = code => {
        window.open(`${Config.API_BASE_URL}/api/wholesalers/download/${code}`, '_blank');
    };

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <div className="flex align-items-start flex-column lg:justify-content-between lg:flex-row">
                        <div>
                            <div className="font-medium text-3xl text-900 mb-3">Elenco dei prodotti forniti da {_.capitalize(wholesaler.name)}</div>
                            <div className="text-500 mb-5">Ultimo aggiornamento {(new Date(modificationTime * 1000)).toLocaleString()}</div>
                        </div>
                        <div className="mt-3 lg:mt-0">
                            <Button
                                icon={PrimeIcons.DOWNLOAD}
                                label="Scarica CSV"
                                onClick={() => download(code)}
                            />
                        </div>
                    </div>

                    <DataTable
                      className="p-datatable-gridlines"
                      responsiveLayout="scroll"
                      lazy
                      dataKey="id"
                      value={data}
                      paginator
                      showGridlines
                      first={lazyParams.first}
                      rows={lazyParams.rows}
                      totalRecords={data.length}
                      filters={lazyParams.filters}
                      filterDisplay="row"
                      onFilter={onFilter}
                      sortField={lazyParams.sortField}
                      sortOrder={lazyParams.sortOrder}
                      onSort={onSort}
                      onPage={onPage}
                      loading={loading}
                      emptyMessage="Nessun prodotto trovato."
                    >
                      <Column header="AIC" field="aic" filter showFilterMenu={false} style={{ maxWidth: '150px' }} />
                      <Column field="name" header="Nome" />
                      <Column field="quantity" header="Quantità" />
                      <Column field="cost" header="Costo" body={rowCost} />
                      <Column field="price" header="Prezzo" body={rowPrice} />
                      <Column field="suggested_price" header="Prezzo di vendita" body={rowSuggestedPrice} />
                    </DataTable>
                </div>
            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(WholesalerData, comparisonFn);
